import React from 'react';
import styles from './Reward.module.scss';
import { ReactComponent as HeartIcon } from '@/assets/Icons/heart.svg';
import { ReactComponent as StarIcon } from '@/assets/Icons/starIcon.svg';
interface RewardProps {
  amount?: number | string;
  showType?: boolean;
  type?: string;
  text?: string;
}

export const Reward: React.FC<RewardProps> = ({ amount, text, type }) => {
  return (
    <>
      {type === 'hearts' && (
        <div className={styles.reward}>
          <HeartIcon />
          <div className={styles.rewardText}>
            {amount}
            {text}
          </div>
        </div>
      )}
      {type === 'stars' && (
        <div className={styles.reward}>
          <StarIcon />
          <div className={styles.rewardTextStars}>
            {amount}
            {text}
          </div>
        </div>
      )}
    </>
  );
};
